<template>
  <v-container>
    <v-layout justify-center wrap>
      <v-flex md1>
        <v-text-field solo v-model="category_id" class="mr-2"></v-text-field>
      </v-flex>
      <v-flex md9>
        <v-text-field solo v-model="category_url" class="mr-2"></v-text-field>
      </v-flex>
      <v-flex md2>
        <v-btn color="primary" :loading="searching" @click="startSearch">Search</v-btn>
      </v-flex>
    </v-layout>
    <v-layout justify-center wrap>
      <v-flex xs12 sm12 md10 lg8>
        <!-- <ScrapedItem v-for="(item, i) in scraped_items" :key="i" :item="item" style="margin-bottom: 2px;"/> -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ScrapedItem from '../components/ScrapedItem';

export default {
  components: {
    ScrapedItem
  }, 
  data: () => ({
    searching: false,
    count: 0,
    num_pages: 0,

    category_id: '',
    category_url: '',

    product_ids: [],
    scraped_items: [],
  }),
  created(){
  },
  computed: {
  },
  methods: {
    startSearch(){
      this.searching = true
      this.scraped_items = []
      this.count = 0
      this.num_pages = 0
      axios.post('/num-pages-products', {
        // category_id: this.category_id,
        category_url: this.category_url
      })
      .then(response => {
        this.num_pages = response.data.page_num
        for (var i = 0; i < this.num_pages; i++) {
          this.getPageProducts(i)
        }
      })
      .catch(error => {
      })
    },
    async getPageProducts(page_num){
      var self = this
      await axios.post('scrape-by-category', {
        page_num: page_num,
        category_url: this.category_url
      })
      .then(response => {
        var items = response.data.items
        items.forEach(function(item){
          self.scraped_items.push(item)
        })
        self.count++;
        if(self.count >= self.num_pages){
          axios.post('scrape-to-csv', {
            category_id: this.category_id,
            items: self.scraped_items
          })
          .then(response => {
            this.searching = false
            console.log(response)
            this.category_id = ''
            this.category_url = ''
            window.open(response.data.url)
          })
        }
      })
      .catch(error => {
      })
    },
  }
};
</script>
